export default __webpack_public_path__ + "static/media/IconDesc_SpelevatorPart_2.256.7ffde4e7.png";